import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UseCase } from '@/domain/core/UseCase'
import { UserChart } from '@/domain/models/UserChart'
import { Result } from '@/domain/protocols/Result'

import type { IUserChartRepository } from '@/data/UserChartRepository/IUserChartRepository'

export class LoadUserChartsUseCase implements UseCase<void, Promise<Result<UserChart[]>>> {
  private repository: IUserChartRepository

  constructor(repository?: IUserChartRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IUserChartRepository>(InjectionTokens.UserChartRepository)
  }

  async execute(): Promise<Result<UserChart[]>> {
    try {
      return await this.repository.getCharts()
    } catch (error) {
      return Result.fail(error)
    }
  }
}
